<template>
  <div class="fixedMean" style="display: block;" v-if="Object.keys(agentInfo).length > 0 && show">
    <ul>
      <li>
        <a class="qqzixun" target="_blank" :href="`http://wpa.qq.com/msgrd?v=3&amp;uin=${agentInfo.qqCode}&amp;amp;site=qq&amp;amp;menu=yes`">QQ咨询</a>
        <span class="line"></span>
      </li>
      <li>
        <p class="telzixun">微信咨询<img class="weixinerweima" :src="agentInfo.wechatQRCode" alt="" style="width:92px;height:92px;"></p>
        <span class="line" style="margin-top:5px;"></span>
      </li>
      <li>
        <p class="telzixun">电话咨询<br>{{agentInfo.mobilePhone}}</p>
      </li>
    </ul>
    <Icon type="ios-close" @click="show = false" />
  </div>
</template>

<script>
export default {
  name: "Advisory",
  data() {
    return {
      show: true
    }
  },
  computed: {
    agentInfo() {
      return this.$store.getters["globe/agentInfo"]
    }
  }
}
</script>

<style lang="scss" scope>
  .fixedMean {position: fixed;top: 25%;right: 35px;width: 128px;padding:0px;text-align: center;background: linear-gradient(85deg, #e86552, #cc3332);font-size:14px;padding-bottom:6px;border-radius:8px;z-index: 99;}
  .fixedMean .ivu-icon{
    position: absolute;
    top: 0;
    right: 0;
    font-size: 28px;
    color: white;
    cursor: pointer;
  }
  .fixedMean ul, .fixedMean p{padding: 0px;margin:0px;}
  .fixedMean li {list-style: none;color: #fff;padding:5px 0px;}
  .fixedMean a {text-align: center;color: #fff;text-decoration: none;display:block;}
  .fixedMean a.qqzixun{padding:10px 0px;background:url(../../assets/img/qq-icon.png) no-repeat 15px 8px;padding-left:15px;}
  .fixedMean li a:hover{background-color:rgba(0,0,0,.1);color:#ff0;}
  .fixedMean ul li .line {display: block;background: url(https://img2.233.com/wx/youshi/pc/icon.png) no-repeat -378px -26px;width: 114px;height: 2px;margin:0px auto;}
</style>